import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-search.tsx
/**
* icon.24.search
*
* Keywords: magnifying-glass, zoom, find, inspect, examine, lens, discovery, investigation
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTExLjUgNmE1LjUgNS41IDAgMCAxIDQuMjI2IDkuMDE5bDIuMTI3IDIuMTI3YS41LjUgMCAxIDEtLjcwNy43MDdsLTIuMTI3LTIuMTI3QTUuNSA1LjUgMCAxIDEgMTEuNSA2bTAgMWE0LjUgNC41IDAgMSAwIDAgOSA0LjUgNC41IDAgMCAwIDAtOSIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-733
*/
const Icon24Search = memo(function Icon24Search(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M11.5 6a5.5 5.5 0 0 1 4.226 9.019l2.127 2.127a.5.5 0 1 1-.707.707l-2.127-2.127A5.5 5.5 0 1 1 11.5 6m0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9"
		})
	});
});
//#endregion
export { Icon24Search };

//# sourceMappingURL=icon-24-search.js.map